/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactForPageViewDto } from './contactForPageViewDto';


export interface EditPageRequestDto { 
    title: string;
    contentText?: string;
    showInMenu: boolean;
    sortOrder: number;
    contacts?: Array<ContactForPageViewDto>;
    id: string;
}

